import { render } from "./ProductExtra.vue?vue&type=template&id=f33e3256&scoped=true"
import script from "./ProductExtra.vue?vue&type=script&lang=js"
export * from "./ProductExtra.vue?vue&type=script&lang=js"

import "./ProductExtra.vue?vue&type=style&index=0&id=f33e3256&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f33e3256"]])

export default __exports__